import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { styled, alpha } from "@mui/material/styles";
import "./card.scss";
import Grid from "@mui/material/Grid";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import PlaceIcon from "@mui/icons-material/Place";
import { useSelector, useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { setCalendar } from "../../store/calendarSelector";
import api from "../../api";

const BCard = styled(Card)(({ theme }) => ({
  minWidth: 375,
  marginTop: "30px",
  color: theme.palette.text.banner,
  backgroundColor: alpha(theme.color.main, 1),
}));

const Status = styled("span")(({ theme }) => ({
  borderRadius: "3px",
  padding: "5px",
  color: "rgb(255,0,0)",
  //   border: "2px solid #007bff", // Линия рамки
  backgroundColor: alpha(theme.color.body, 1),
}));

const Ex = styled("span")(({ theme }) => ({
  borderRadius: "3px",
  padding: "5px",
  color: theme.color.secondary,
  //   border: "2px solid #007bff", // Линия рамки
  backgroundColor: alpha(theme.color.body, 1),
}));

const But = styled(Button)(({ theme }) => ({
  borderRadius: "3px",
  padding: "5px",
  color: theme.color.secondary,
  //   border: "2px solid #007bff", // Линия рамки
  backgroundColor: alpha(theme.color.body, 1),
  variant: "outlined",
  size: "small",
}));

const bull = (
  <Box
    component="span"
    sx={{ display: "inline-block", mx: "2px", transform: "scale(0.8)" }}
  >
    •
  </Box>
);

export default function BannerCard() {
  const dispatch = useDispatch();
  const getCalFunc = () => {
    api.getCal().then((response) => {
      dispatch(setCalendar(response.data.cal));
    });
  };

  const calendar = useSelector((state) => state.calendarSelector.calendar);

  useEffect(() => {
    getCalFunc();
  }, []);
  return calendar[0] ? (
    <BCard
    //   sx={{
    //     minWidth: 375,
    //     marginTop: "30px",
    //     color: theme.palette.text.banner,
    //   }}
    >
      <CardContent>
        <Grid container direction="rows">
          <div className="blinking-dot"></div>
          <Typography
            gutterBottom
            sx={{ color: "text.secondary", fontSize: 14 }}
          >
            Ближайший старт
          </Typography>
        </Grid>

        <Status>{calendar[0]["status"]}</Status>

        <Typography variant="h6" component="div">
          {calendar[0]["name"]}
        </Typography>
        <Grid container direction="rows">
          <CalendarMonthIcon />
          <Typography sx={{ color: "text.secondary", mb: 1.5, margin: "3px" }}>
            {calendar[0]["start"]}
          </Typography>
          <PlaceIcon />
          <Typography sx={{ color: "text.secondary", mb: 1.5, margin: "3px" }}>
            {calendar[0]["place"]}
          </Typography>
        </Grid>

        <Ex>{calendar[0]["disciplina"]}</Ex>
      </CardContent>
      <CardActions>
        <But
          //   disabled={pass}

          href={calendar[0]["zayav"]}
        >
          отправить заявку
        </But>
        {calendar[0]["polog"] ? (
          <But
            // disabled={calendar[0]["polog"] ? false : true}
            href={calendar[0]["polog"]}
          >
            положение
          </But>
        ) : (
          <h1></h1>
        )}
      </CardActions>
    </BCard>
  ) : (
    <BCard
    //   sx={{
    //     minWidth: 375,
    //     marginTop: "30px",
    //     color: theme.palette.text.banner,
    //   }}
    >
      <CardContent>
        <Grid container direction="rows">
          <div className="blinking-dot"></div>
          <Typography
            gutterBottom
            sx={{ color: "text.secondary", fontSize: 14 }}
          >
            Ближайшие соревнования
          </Typography>
        </Grid>

        <Status>Ожидаем</Status>

        <Typography variant="h6" component="div">
          Пока нет доступных стартов
        </Typography>
        <Grid container direction="rows">
          <CalendarMonthIcon />
          <Typography sx={{ color: "text.secondary", mb: 1.5, margin: "3px" }}>
            дата
          </Typography>
          <PlaceIcon />
          <Typography sx={{ color: "text.secondary", mb: 1.5, margin: "3px" }}>
            место
          </Typography>
        </Grid>

        {/* <Ex>жим</Ex> */}
      </CardContent>
      <CardActions>
        <But
          disabled={true}

          //   onClick={() => pass}
        >
          отправить заявку
        </But>
      </CardActions>
    </BCard>
  );
}
